module.exports = __webpack_public_path__ + "img/sydq.af75259d.png";